import { FiGrid, FiSliders, FiTerminal, FiFileMinus } from "react-icons/fi";
import { PiPaletteLight } from "react-icons/pi";
import batteryrnd from "../../assets/appication/battery_R_n_D.webp";
import chemicalRnD from "../../assets/appication/chemical_research.jpg";
import nano from "../../assets/appication/nano.jpeg";
import nuclear from "../../assets/appication/nuclear_lab.jpg";
import oled from "../../assets/appication/oled.webp";
export const ApplicationData = {
  hero: {
    title: "ProRes ",
    title2: "Applications",
    subTitle: "Engineered for Critical Research & Industrial Environments",
    imgUrl:
      "https://proresglovebox.com/wp-content/uploads/2025/02/NITK-Surathkal-1.jpg",
  },

  applicationData: {
    title: "Application Areas",
    subTitle: "Where Precision Matters",
    applicationList: [
      {
        id: "Application 01",
        title: "Battery Research & Development",
        desc: "Controlled inert environments for electrode fabrication, electrolyte handling, cell assembly, and advanced battery material research.",
        img: batteryrnd,
        forceRight: false,
      },
      {
        id: "Application 02",
        title: "Chemical & Pharmaceutical Research",
        desc: "Safe and contamination-free handling of air-sensitive, toxic, and reactive chemical compounds.",
        img: chemicalRnD,
        forceRight: true,
      },
      {
        id: "Application 03",
        title: "Nuclear & Defense Laboratories",
        desc: "High-security containment systems designed for nuclear material handling and defense research facilities.",
        img: nuclear,
        forceRight: false,
      },
      {
        id: "Application 04",
        title: "OLED & Semiconductor Research",
        desc: "Ultra-low oxygen and moisture environments supporting OLED fabrication and semiconductor material processing.",
        img: oled,
        forceRight: true,
      },
      {
        id: "Application 05",
        title: "Advanced Materials & Nanotechnology",
        desc: "Precision gloveboxes for graphene, nanomaterials, and emerging advanced material research.",
        img: nano,
        forceRight: false,
      },
    ],
  },

  benefitsOfGloveBox: {
    title: "Key Benefits of ProRes Glovebox Systems",
    subTitle:
      "High-performance features designed to ensure safety, accuracy, and long-term reliability.",
    benefitsList: [
      {
        icon: <FiTerminal size={42} className="text-red-600" />,
        title: "Ultra-Low Oxygen & Moisture Levels",
        desc: "Achieve <1 ppm O₂ and H₂O for highly sensitive processes requiring stable inert atmospheres.",
      },
      {
        icon: <FiGrid size={42} className="text-red-600" />,
        title: "Modular & Scalable Design",
        desc: "Expandable glovebox configurations to support evolving research and production requirements.",
      },
      {
        icon: <FiSliders size={42} className="text-red-600" />,
        title: "Advanced Purification Technology",
        desc: "High-efficiency gas purification systems ensuring consistent atmosphere quality over extended operation.",
      },
      {
        icon: <FiFileMinus size={42} className="text-red-600" />,
        title: "Enhanced Operator Safety",
        desc: "Integrated safety interlocks, pressure control, and filtration to protect users and sensitive materials.",
      },
      {
        icon: <FiFileMinus size={42} className="text-red-600" />,
        title: "Precision Process Control",
        desc: "Accurate monitoring and control of pressure, gas flow, and environmental parameters.",
      },
      {
        icon: <PiPaletteLight size={42} className="text-red-600" />,
        title: "Customization & Integration",
        desc: "Custom ports, antechambers, automation, and instrument integration tailored to specific applications.",
      },
    ],
  },

  needCustom: {
    imgUrl: "",
    title: "Have a Specialized Application?",
    description:
      "Our engineering team collaborates closely with researchers and manufacturers to design fully customized glovebox solutions for unique processes and challenging environments.",
    ctaText: "+91 98446 06132",
  },

  successStoriesData: {
    subTitle: "Success Stories",
    title: "Proven Performance Across Industries",
    description:
      "Discover how ProRes glovebox systems enable precision, safety, and breakthrough results in real-world applications.",
    storiesList: [
      {
        title: "Next-Generation Battery Materials",
        client: "Electric Vehicle Battery Manufacturer",
        description:
          "ProRes glovebox systems enabled moisture-free handling of solid-state electrolytes, ensuring consistent electrode fabrication and material integrity.",
        result:
          "40% improvement in cycle life and enhanced cell-to-cell consistency.",
        date: "12 Sep 2024",
      },
      {
        title: "Air-Sensitive Pharmaceutical Research",
        client: "Global Pharmaceutical R&D Center",
        description:
          "Custom glovebox integration allowed stable handling of air-reactive catalysts previously unusable under ambient conditions.",
        result:
          "Development of three new catalyst formulations with significantly improved yields.",
        date: "08 Sep 2024",
      },
      {
        title: "Reactive Metal Powder Processing",
        client: "Aerospace Components Manufacturer",
        description:
          "Controlled inert environments eliminated oxidation during metal powder preparation for additive manufacturing.",
        result:
          "Near-zero defect rates and enhanced component purity.",
        date: "03 Sep 2024",
      },
    ],
  },
};
